import React, { useState, useEffect } from 'react';
import { Dialog, Drawer } from '@mui/material';
import PropTypes from 'prop-types';
import { useModalManager } from './ModalManagerContext'; 


const MUI_COMPONENTS = {
  dialog: Dialog,
  drawer: Drawer,
};

/**
 * Component quản lý hiển thị Modal/Drawer tập trung với hệ thống tự động tính Z-Index.
 * @param {Object} props
 * @param {boolean} props.open - Trạng thái hiển thị
 * @param {'dialog' | 'drawer'} [props.type='dialog']
 */
export default function ManagedModal({ 
  open, 
  type = 'dialog', 
  ...props 
}) {
  const modalManager = useModalManager();
  const requestZIndex = modalManager?.requestZIndex;
  const releaseZIndex = modalManager?.releaseZIndex;

  const [modalId] = useState(() => `managed_${type}_` + Date.now() + Math.random().toString(36).slice(2, 7));
  
  const [localZIndex, setLocalZIndex] = useState(undefined);

  useEffect(() => {
    if (open && requestZIndex) {
      const grantedZIndex = requestZIndex(modalId);
      setLocalZIndex(grantedZIndex);
    }
    
    return () => {
      if (releaseZIndex) {
        releaseZIndex(modalId);
      }
    };
  }, [open, modalId, requestZIndex, releaseZIndex]);

  const ComponentToRender = MUI_COMPONENTS[type];

  if (!ComponentToRender) {
    console.error(`ManagedModal: Không hỗ trợ type '${type}'.`);
    return null;
  }

  return (
    <ComponentToRender
      open={open}
      {...props}
      sx={{ 
        ...props.sx,
        ...(localZIndex !== undefined ? { zIndex: localZIndex } : {})
      }}
    >
      {props.children}
    </ComponentToRender>
  );
}

// Cập nhật PropTypes để bắt lỗi
ManagedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['dialog', 'drawer'])
};